import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.userList,
    component: () => import('../../pages/userManagement/userList/list'),
    meta: { title: '用户列表' }
  },
  {
    path: routeNames.userLevel,
    component: () => import('../../pages/userManagement/userLevel/list'),
    meta: { title: '会员等级管理' }
  },
  {
    path: routeNames.userDetail,
    component: () => import('../../pages/userManagement/userDetail/list'),
    meta: {
      title: '用户详情',
      hideInMenu: true
    }
  },
  {
    path: routeNames.userDetailIntegral,
    component: () => import('../../pages/userManagement/userDetail/integral'),
    meta: {
      title: '积分详情',
      hideInMenu: true
    }
  },
  {
    path: routeNames.userDetailUp,
    component: () => import('../../pages/userManagement/userDetail/up'),
    meta: {
      title: '成长值详情',
      hideInMenu: true
    }
  },
  {
    path: routeNames.userDetailInvitation,
    component: () => import('../../pages/userManagement/userDetail/invitation'),
    meta: {
      title: '邀请好友记录',
      hideInMenu: true
    }
  },
  {
    path: routeNames.userDetailTags,
    component: () => import('../../pages/userManagement/userDetail/tags'),
    meta: {
      title: '标签信息',
      hideInMenu: true
    }
  },
  {
    path: routeNames.unactivedUsers,
    component: () => import('../../pages/userManagement/UnactivedUsers'),
    meta: { title: '未激活用户列表' }
  },
  {
    path: routeNames.userGroup,
    component: () => import('../../pages/userManagement/userGroup/list'),
    meta: { title: '用户分组' }
  },
  {
    path: routeNames.userGroupBuild,
    component: () => import('../../pages/userManagement/userGroup/build'),
    meta: {
      title: '新建分组',
      hideInMenu: true
    }
  },
  {
    path: routeNames.userGroupAdd,
    component: () => import('../../pages/userManagement/userGroup/add'),
    meta: {
      title: '批量添加',
      hideInMenu: true
    }
  },
  {
    path: routeNames.crmManagement,
    component: () => import('../../pages/userManagement/userCrm/management'),
    meta: { title: 'crm短信投递管理' }
  },
  {
    path: routeNames.crmCreate,
    component: () => import('../../pages/userManagement/userCrm/create'),
    meta: {
      title: 'crm投递新建',
      hideInMenu: true
    }
  },
  {
    path: routeNames.crmResult,
    component: () => import('../../pages/userManagement/userCrm/result'),
    meta: {
      title: 'crm投递结果查看',
      hideInMenu: true
    }
  },
  {
    path: routeNames.crmEdit,
    component: () => import('../../pages/userManagement/userCrm/edit'),
    meta: {
      title: 'crm编辑投递用户',
      hideInMenu: true
    }
  },
  {
    path: routeNames.crmGroup,
    component: () => import('../../pages/userManagement/userCrm/group'),
    meta: {
      title: 'crm选择用户组添加',
      hideInMenu: true
    }
  },
  {
    path: routeNames.balanceDetail,
    component: () => import('../../pages/userManagement/userDetail/balanceDetail'),
    meta: {
      title: '余额详情',
      hideInMenu: true
    }
  },
  {
    path: routeNames.rightsManagement,
    component: () => import('../../pages/userManagement/rightsManagement/list'),
    meta: { title: '权益管理' }
  },
  {
    path: routeNames.uriExchange,
    component: () => import('../../pages/userManagement/uriExchange'),
    meta: { title: '小程序转链' }
  }
] as TRoutes[]
